import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { logos, icons, MAIL_FORMATTING } from "../helpers/constants";
import Button from '../components/Buttons/Button';
import LanguagePicker from '../components/LanguagePicker';
import * as request from "../services/FetchService";
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../helpers/customHooks';
import TosModal from '../components/Modals/TosModal';
import { useContextData } from '../components/ContextData'; // Adjust the path as necessary
import { useParams } from "react-router";
import toast from 'react-hot-toast';
import NewButton from '../components/Buttons/NewButton';

const SignupInviteNew = (props) => {
    const MOBILE = useIsMobile();
    const navigate = useNavigate()
    let params = useParams();
    const { accessToken, setAccessToken } = useContextData();
	const { t } = useTranslation();
    const [email, setEmail] = useState("")
    const [emailConfirm, setEmailConfirm] = useState("")
    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [invalidEmailConfirm, setInvalidEmailConfirm] = useState(false)
    const [username, setUsername] = useState("")
    const [imei, setImei] = useState("")
    const [policy, setPolicy] = useState(false)
    const [location, setLocation] = useState(false)
    const [step, setStep] = useState(1)
    const [errors, setErrors] = useState({})
    const [token, setToken] = useState("")
	const [modals, setModals] = useState({
		tos: false,
		privacy: false
	})
    const [devicename, setDevicename] = useState("")


    useEffect(() => {
        decodeToken()
    },[])

    const decoder = (string) => {
        return atob(string)
    }

    const decodeToken = () => {
        let auth = decoder(params.token);
        let split = auth.split(':');
        setEmail(split[0])
        setToken(params.token)
        // setEmail(AuthorizationSplit[0])
        // setToken(AuthorizationSplit[1])
      }
    
    const handleChange = (type, e) => {
        const value = e.target.value;

        setErrors((prev) => {
            let next = { ...prev };
            switch (type) {
                case "email":
                    setEmail(value);
                    next.email = !MAIL_FORMATTING.test(value) && value !== "";
                    // Compare using the new email value and current confirm value
                    next.mismatch = value !== emailConfirm && value !== "";
                    break;

                case "emailConfirm":
                    setEmailConfirm(value);
                    next.email_confirm = !MAIL_FORMATTING.test(value) && value !== "";
                    // Compare using the current email value and new confirm value
                    next.mismatch = email !== value && value !== "";
                    break;

                case "password":
                    setPassword(value);
                    next.password = password < 6 && value !== "";
                    next.password_mismatch = value !== passwordConfirm && value !== "";
                    break;

                case "passwordConfirm":
                    setPasswordConfirm(value);
                    next.password_confirm = passwordConfirm < 6 && value !== "";
                    next.password_mismatch = value !== password && value !== "";
                    break;
                case "username":
                    setUsername(value);
                    next.username = value === ""
                    break;
                case "devicename":
                    setDevicename(value);
                    next.devicename = value === ""
                    break;
                case "imei":
                    setImei(value);
                    next.imei = value === "" && value.length < 10 && value !== "";
                    break;
                default:
                    return prev;
            }

            return next;
        });
    };

	const toggleModal = (modalName) => {
        setModals((prevState) => ({
            ...prevState,
            [modalName]: !prevState[modalName],
        }));
    };

    const validateInputs = (page) => {
        let innerErrors = {}
        if(page === 1){
            innerErrors = {
                email: !MAIL_FORMATTING.test(email),
                policy: !policy,
                location: !location   
            }
        }else if(page === 2){
            innerErrors = {
                password: password.length<6,
                password_confirm: passwordConfirm.length<6,
                password_mismatch: password !== passwordConfirm
            }
        }else if(page === 3){
            innerErrors = {
                username: username.length<1
            }
        }else if(page === 4){
            innerErrors = {
                imei: imei.length < 10
            }
        }
        setErrors(innerErrors)
        return innerErrors
    }

    const handleNext = (page) => {
       const hasErrors = validateInputs(page)
        if(!Object.values(hasErrors).some(value => value === true) && step < 3){
            setStep(step+1)
        }else if(!Object.values(hasErrors).some(value => value === true) && step === 3){
            createAccount()
        }
    }

    const handleLoginSuccess = async (token) => {
        localStorage.setItem("accesstoken", token)
        await setAccessToken(token)
        navigate("/devices")
    }


    const createAccount = () => {
        const lang = localStorage.getItem("language") ?? "en";        
        const data = {
            username: username,
            password: password,
            invitetoken: token,
            language: lang
        }
        request.post("", "account/createfromshared", data).then((response) => {
            if(response.data.error){
                toast.error(response.data.message)
                setErrors((prevState) => ({
                    ...prevState,
                    imei: true
                }))
            }else if(response.data.successful){
                handleLoginSuccess(response.data.accessToken)
            }
        })

    }

    const goBack = () => {
        if(step === 1){
            navigate("/login")
        }else{
            setStep(step-1)
        }
    }

    const step1 = () => {
        return(
        <>
            <div className="mt-3">
                <h1 className="mb-2">1. {t("signup.email")}</h1>
                <p>{t("signup.email_sub_invite")}</p>
            </div>
            <form>
                <p className="bold mt-3">{t("signup.email")}</p>
                <div className="form-group position-relative mb-5">
                    <input
                        type="email"
                        placeholder=""
                        className={`form-control rounded16 p-3 ${errors.email && "error-border"}`}
                        id="email"
                        name="email"
                        disabled={true}
                        readOnly={true}
                        value={email}
                        onChange={(e) => {
                            handleChange("email", e);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent the default Enter key behavior
                                document.getElementById("emailConfirm").focus();
                            }
                        }}
                    />
                    <div className="d-flex justify-content-between position-relative">
                        <p className="red bold position-absolute mt-1">{errors.email ? t("signup.invalid_email") : ""}</p>
                    </div>
                </div>
            </form>
            <div className="d-flex flex-column position-relative pb-3 mt-4">
                <div className="d-flex align-items-center justify-content-between">       
                    <p className="grey-blue">
                        <Trans
                            i18nKey="signup.policy_tos"
                            components={{
                            policy: <span className="cursor-pointer underline" onClick={() => toggleModal("tos")} />,
                            terms: <span className="cursor-pointer underline" onClick={() => toggleModal("tos")} />,
                            }}
                            values={{
                            policy: t("signup.policy"),
                            terms: t("signup.terms")
                            }}
                        />
                    </p>
                    <div className={`checkbox-${policy ? "active" : "inactive"} rounded8 size_20 d-flex justify-content-center p-1 cursor-pointer`} onClick={() => !policy ? toggleModal("tos") : ""}>
                        {policy && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>

                </div>
                <p className="red bold position-absolute start-0 bottom-0">
                    {!policy && errors.policy ? t("signup.must_accept_policy") : ""}
                </p>
            </div>
            <div className="d-flex flex-column position-relative pb-3 mt-3">
                <div className="d-flex align-items-center justify-content-between">
                    <p className="grey-blue">{t("signup.location_data")}</p>
                    <div className={`checkbox-${location ? "active" : "inactive"} rounded8 size_20 d-flex justify-content-center p-1 cursor-pointer`} onClick={() => setLocation(!location)}>
                        {location && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>
                </div>
                <p className="red bold position-absolute start-0 bottom-0">
                    {!location && errors.location ? t("signup.must_accept_location") : ""}
                </p>
            </div>
            <NewButton className="bg-gradient white-white bold mt-5 rounded16 p-3" onClick={() => handleNext(1)}>{t("signup.next")}</NewButton>
        </>
        )
    }
    const step2 = () => {
        return (
			<>
                <div className='mt-3'>
                    <h1 className='mb-2'>2. {t("signup.password")}</h1>
                    <p>{t("signup.password_sub")}</p>
                </div>
				<form>
					<p className="bold mt-3">{t("signup.password")}</p>
					<div className="form-group position-relative mb-5">
						<input
							type="password"
							placeholder=""
							className={`form-control rounded16 p-3 ${errors.password && "error-border"}`}
							name="password"
							value={password}
							onChange={(e) => {
								handleChange("password", e);
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault(); // Prevent the default Enter key behavior
									document.getElementById("passwordConfirm").focus();
								}
							}}
						/>
						<div className="d-flex justify-content-between position-relative">
							<p className="red bold position-absolute mt-1">{errors.password ? t("signup.invalid_password") : errors.password_mismatch ? t("signup.password_mismatch") : ""}</p>
						</div>
					</div>
					<div className="form-group mt-3">
						<p className="bold">{t("signup.password_confirm")}</p>
						<input
							type="password"
							placeholder=""
							className={`form-control rounded16 p-3 ${errors.password_confirm && "error-border"}`}
							name="passwordConfirm"
							id="passwordConfirm"
							value={passwordConfirm}
							onChange={(e) => {
								handleChange("passwordConfirm", e);
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();// Prevent the default Enter key behavior
                                    handleNext(2)
								}
							}}
						/>
						<div className="d-flex justify-content-between position-relative">
							<p className="red bold position-absolute mt-1">{errors.password_confirm ? t("signup.invalid_password") : errors.password_mismatch ? t("signup.password_mismatch") : ""}</p>
						</div>
					</div>
				</form>
                <NewButton className="bg-gradient white-white bold mt-5 rounded16 p-3" onClick={() => handleNext(2)}>{t("signup.next")}</NewButton>
			</>
		);
    }

    const step3 = () => {
        return (
			<>
                <div className='mt-3'>
                    <h1 className='mb-2'>3. {t("signup.account_details")}</h1>
                    <p>{t("signup.account_details_sub")}</p>
                </div>
				<form>
					<p className="bold mt-3">{t("login.username")}</p>
					<div className="form-group position-relative mb-5">
						<input
							type="text"
							placeholder=""
							className={`form-control rounded16 p-3 ${errors.username && "error-border"}`}
							name="username"
							value={username}
							onChange={(e) => {
								handleChange("username", e);
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault(); // Prevent the default Enter key behavior
									handleNext(3);
								}
							}}
						/>
						<div className="d-flex justify-content-between position-relative">
							<p className="red bold position-absolute mt-1">{errors.username ? t("signup.invalid_username") : ""}</p>
						</div>
					</div>
				</form>
                <NewButton className="bg-gradient white-white bold mt-5 rounded16 p-3" onClick={() => handleNext(3)}>{t("signup.next")}</NewButton>
			</>
		);
    }

    // const step4 = () => {
    //     return(
    //         <>
    //             <h1>4. {t("signup.imei")}</h1>
    //             <p>{t("signup.imei_sub")}</p>
    //             <form>
    //                 <div className="form-floating form-floating-group flex-grow-1 is-valid mb-2">
    //                     <input
    //                         type="text"
    //                         placeholder="0"
    //                         id="imei"
    //                         className="form-control login-input-field pe-4"
    //                         name="imei"
    //                         value={imei}
    //                         onChange={(e) => {
    //                             handleChange("imei", e);
    //                         }}
    //                         onKeyDown={(e) => {
    //                             if (e.key === 'Enter') {
    //                             e.preventDefault();// Prevent the default Enter key behavior
    //                             handleNext(4)
    //                             }
    //                         }}
    //                     />
    //                     <label htmlFor="floatingInput">
    //                         {t("signup.imei")}
    //                     </label>
    //                     <div className="invalid-feedback ms-1 bottom">
    //                     {errors.imei ? t("signup.invalid_imei") : ""}
    //                     </div>
    //                 </div>
    //             </form>
    //             <Button btnClass="btn-primary mt-5" onClick={() => handleNext(4)}>{t("signup.create_account")}</Button>
    //         </>
    //     ) 
    // }

    return(
        <>
            <div className="d-flex flex-column loginfield mx-auto h-100 px-3 px-md-0">
				<NewButton notext={true} icon={icons.chevron_left} iconClass={"grey-blue-icon"} className={`position-absolute my-auto ms-2 border-sm bg-white full-rounded size_36 p-3`} onClick={() => goBack()} />
				<img src={logos.big} className="login_logo mx-auto mb-3" alt="logo" />
				{step === 1 ? step1() : step === 2 ? step2() : step === 3 ? step3() : null}
			</div>
            <div className={`position-absolute left-0 bottom-0 ms-4 mb-4 ms-lg-5 mb-lg-5 bg-grey cursor-pointer rounded`}>
				<LanguagePicker />
			</div>
			<TosModal show={modals.tos} accept={() => setPolicy(true)} onClose={() => toggleModal("tos")} />
        </>
        /* 
        <>
        <div className="container-fluid h-100">
            <div className="d-flex justify-content-center h-100">
                <div className={`d-flex flex-column justify-content-center ${MOBILE ? "w-100 px-4" : "w-25"} dvh-100`}>
                    <Button className="align-self-start" icon={icons.back} notext={true} onClick={() => goBack()}/>
                    <img className="login_logo mx-auto mb-5" src={logos.big} alt="logo"/>
                    {
                        step === 1 
                        ? step1()
                        : step === 2
                        ? step2()
                        : step === 3
                        ? step3()
                        : null
                    }
                    <div className='d-flex justify-content-center mt-3'>
                        <img className="me-2" src={step >= 1 ? icons.dot_selected : icons.dot_unselected} alt=""/>
                        <img className="me-2" src={step >= 2 ? icons.dot_selected : icons.dot_unselected} alt=""/>
                        <img className="me-2" src={step >= 3 ? icons.dot_selected : icons.dot_unselected} alt=""/>
                    </div>
                </div>
            </div>
        </div>
        <div className={`position-absolute left-0 bottom-0 ${MOBILE ? "ms-2 mb-2" : "ms-5 mb-5"} bg-grey cursor-pointer rounded`}>
            <LanguagePicker />
        </div>
        <TosModal show={modals.tos} accept={() => setPolicy(true)} onClose={() => toggleModal("tos")} />
        </>
        */
    )
}

export default SignupInviteNew;